import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import ProfileCard from '../platform/dashboard/ProfileCard'
import { defaultProfPic } from './Utils'

export const HamburgerNavigationMenu = ({ className, setShowHamburgerMenu, showHamburgerMenu }) => {
  return (
    <div
      className="topnav d-column-flex d-md-none position-fixed vh-100 overflow-hidden"
      style={{
        top: '0',
        right: showHamburgerMenu ? '0' : '-100vw',
        zIndex: '30',
        width: '100vw',
        transition: '200ms',
        backgroundColor: 'var(--homepage-background)',
        border: '1px solid black'
      }}
    >
      {/* <a className="cursor-pointer" onClick={() => setShowHamburgerMenu(false)}>
                <img className="px-1 py-1" src="/static/icons/close_black_24dp.svg" style={{ width: '40px', height: '40px' }} />
            </a> */}
      <div className="w-100">
        <VerticalNavigationMenu className={className} white={false} />
      </div>
    </div>
  )
}

export const VerticalNavigationMenu = ({
  className,
  white
}: {
  className: string
  white: boolean
}) => {
  return (
    <>
      <div
        style={{ fontSize: '1.3rem' }}
        className={
          'container-fluid d-column-flex navigation-menu align-items-center justify-content-center ' +
          className
        }
      >
        <div
          className="row d-column-flex align-items-center align-self-center justify-content-center px-1"
          style={{ paddingTop: '96px' }}
        >
          <Link to="/" className="mt-0 mb-3 mx-auto text-start">
            Home
          </Link>
          <a href="/studio" className="my-3 mx-auto text-start">
            Studio
          </a>
          <Link to="/listen" className="my-3 mx-auto text-start">
            Listen
          </Link>
        </div>
        <ProfileCard />
        <div className={'align-items-center justify-content-start px-1 d-flex mt-3'}>
          <a
            className="me-4"
            target="_blank"
            href="https://opensea.io/collection/arpeggi-genesis-studio-pass"
          >
            <img
              className="topnav-img"
              src={'/static/icons/Opensea' + (white ? '_white' : '') + '.svg'}
            />
          </a>
          <a
            className="me-4"
            target="_blank"
            href="https://medium.com/@arpeggilabs/arpeggi-studio-4bf465348d51"
          >
            <img
              className="topnav-img"
              src={'/static/icons/Medium' + (white ? '_white' : '') + '.svg'}
            />
          </a>
          <a className="me-4" target="_blank" href="https://discord.com/invite/yBxhcBwNyg">
            <img
              className="topnav-img"
              src={'/static/icons/Discord' + (white ? '_white' : '') + '.svg'}
            />
          </a>
          <a target="_blank" href="https://twitter.com/arpeggi_labs">
            <img
              className="topnav-img"
              src={'/static/icons/Twitter' + (white ? '_white' : '') + '.svg'}
            />
          </a>
        </div>
      </div>
    </>
  )
}

export const NavigationMenu = ({ className, white }: { className: string; white: boolean }) => {
  // preloading the Images
  React.useEffect(() => {
    new Image().src = '/static/icons/account_circle_black_24dp.svg'
    new Image().src = '/static/icons/favorite_border_black_24dp.svg'
    new Image().src = '/static/icons/inventory_2_black_24dp.svg'
    new Image().src = '/static/icons/logout_black_24dp.svg'
  }, [])

  return (
    <>
      <div className={'d-flex navigation-menu align-items-center justify-content-end ' + className}>
        <div className="d-inline-flex me-4">
          <Link to="/" className="navmenu-link navmenu-link-blue me-4">
            Home
          </Link>
          <a href="/studio" className="navmenu-link navmenu-link-yellow me-4">
            Studio
          </a>
          <Link to="/listen" className="navmenu-link navmenu-link-pink">
            Listen
          </Link>
        </div>
        <div className={'align-items-center justify-content-center px-1 me-4 d-flex'}>
          <a
            className="me-3"
            target="_blank"
            href="https://opensea.io/collection/arpeggi-genesis-studio-pass"
          >
            <img
              className="topnav-img"
              src={'/static/icons/Opensea' + (white ? '_white' : '') + '.svg'}
            />
          </a>
          <a
            className="me-3"
            target="_blank"
            href="https://medium.com/@arpeggilabs/arpeggi-studio-4bf465348d51"
          >
            <img
              className="topnav-img"
              src={'/static/icons/Medium' + (white ? '_white' : '') + '.svg'}
            />
          </a>
          <a className="me-3" target="_blank" href="https://discord.com/invite/yBxhcBwNyg">
            <img
              className="topnav-img"
              src={'/static/icons/Discord' + (white ? '_white' : '') + '.svg'}
            />
          </a>
          <a target="_blank" href="https://twitter.com/arpeggi_labs">
            <img
              className="topnav-img"
              src={'/static/icons/Twitter' + (white ? '_white' : '') + '.svg'}
            />
          </a>
        </div>
        <ProfileCard />
      </div>
    </>
  )
}

NavigationMenu.defaultProps = {
  white: false
}

export const TopnavLogo = () => {
  return (
    <div className="d-flex w-100 unselectable">
      <img
        src="/static/icons/arpeggi-logo.svg"
        className="pe-2"
        style={{ zIndex: '31', width: '35px', height: '35px' }}
      />
      <p className="mb-0 d-none d-md-block" style={{ fontWeight: '700', fontSize: '1.4rem' }}>
        Arpeggi Studio
      </p>
    </div>
  )
}

export const Topnav = () => {
  const { user } = useAuth()
  const [showHamburgerMenu, setShowHamburgerMenu] = React.useState(false)
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth)

  React.useLayoutEffect(() => {
    if (Number(windowWidth) >= 768) setShowHamburgerMenu(false)
  }, [windowWidth])

  React.useEffect(() => {
    function updateSize() {
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener('resize', updateSize)
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  return (
    <>
      <div className="row d-flex-column py-3 topnav" style={{ height: '96px' }}>
        <div className="col-8 col-lg-4 col-xl-6 d-flex align-items-center unselectable">
          <a href="/genesis">
            <TopnavLogo />
          </a>
        </div>
        <div className="col-4 d-md-none d-inline-flex justify-content-end">
          {user !== null && (
            <Link
              className="d-flex align-items-center justify-content-center my-auto"
              style={{ height: '30px', width: '30px' }}
              to={'/profile/' + user.wallet_address + '/'}
            >
              <img
                className="cursor-pointer"
                src={user.profile_picture ? user.profile_picture : defaultProfPic()}
                style={{
                  height: '30px',
                  width: '30px',
                  borderRadius: '50%',
                  border: '1px solid black'
                }}
              />
            </Link>
          )}
          <img
            onClick={() => setShowHamburgerMenu(!showHamburgerMenu)}
            className="my-auto cursor-pointer ms-3 me-2"
            src={
              showHamburgerMenu
                ? '/static/icons/close_black_24dp.svg'
                : '/static/icons/menu_black_24dp.svg'
            }
            style={{ height: '30px', width: '30px', zIndex: '31' }}
          />
        </div>
        <NavigationMenu className="d-none d-md-flex col-12 col-lg-8 col-xl-6" />
      </div>
      <HamburgerNavigationMenu
        setShowHamburgerMenu={setShowHamburgerMenu}
        showHamburgerMenu={showHamburgerMenu}
        className=""
      />
    </>
  )
}
